import { Result } from "../shared/interfaces/Result";

export const ResultsGridAssetCellTemplate = (rowData: Result) => {
  const assetNames = rowData.dataValue.Assets
    ? rowData.dataValue.Assets.filter((asset) => asset.PanelMeasurements.length > 0)
        .map((asset) => asset.AssetName)
        .join(", ")
    : rowData.switchGearName;
  return <>{assetNames}</>;
};
